import axios from '@/resources/libs/axios'

export default {
    list() {
        return axios.get(`/vhe/auxiliaries/project-responsibles/list/all`)
    },
}